
//Function for load more of listing items
export function AjaxLoadMore(){
    (function($) {
        let ppp// Post per page
        let pageNumber;
        let postType = 'competence_area';//$("#more_posts").data('type');
        if (postType == 'competence_area'){
            ppp = 4; // Post per page
            pageNumber = 2;
        }else{
            ppp = 5; // Post per page
            pageNumber = 1;
        }
        
        function load_posts(){
            pageNumber++;
            let str ='&postType=' + postType + '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_items_ajax';
            console.log(str);
            $('p#loading_text').show();
            $("#more_posts").hide();
            $.ajax({
                type: "POST",
                dataType: "html",
                url: ajax_posts.ajaxurl,
                data: str,
                success: function(data){
                    let $data = $(data);
                    console.log($data);
                    if($data.length){
                        $("#ajax_competence").append($data);
                        $('p#loading_text').hide();
                        $("#more_posts").show();
                        $("#more_posts").attr("disabled",false); // Uncomment this if you want to disable the button once all posts are loaded
                    }else{
                        $("#more_posts").hide(); // This will hide the button once all posts have been loaded
                        $('p#loading_text').hide();
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
        
            });
            return false;
        }
        
        $("#more_posts").on("click",function(e){ // When btn is pressed.
            e.preventDefault();
            //$("#more_posts").text('Caricamento..'); // Disable the button, temp.
            load_posts();
        });
    })(jQuery);
}
